module.exports = __webpack_public_path__ + "img/yuyan.69796339.png";